export default __webpack_public_path__ + "static/media/100.1b1a8025.svg";